const userRoles = {
    account: "account",
    admin: "admin",
    analyst: "analyst",
    salesperson: "salesperson",
    cfo: "cfo",
    affiliate: "affiliate",
};
  
export default userRoles;
